module.exports = __webpack_public_path__ + "static/img/serviceBanner.1ea45f9b.png";